import React, { useState } from "react";
import PromoCard from "./PromoCard";
import PromoDialog from "./PromoDialog";

/**
 * Grilla de promociones con su modal de condiciones.
 *
 * Las destacadas van de a dos por fila, ocupando media pantalla cada una; las
 * secundarias ocupan la fila entera y son más bajas. La usan la home y la
 * página de promociones, así que la jerarquía se ve igual en los dos lugares.
 */
const PromoGrid = ({ promotions }) => {

	const [openPromo, setOpenPromo] = useState(null);

	if (promotions.length === 0) return null;

	return (
		<>
			<div className="grid gap-4 md:grid-cols-2 lg:gap-5">
				{
					promotions.map((promo, index) => (
						<div key={ index } className={ promo.destacada ? "" : "md:col-span-2" }>
							<PromoCard promo={ promo } onOpenConditions={ setOpenPromo } />
						</div>
					))
				}
			</div>

			{
				openPromo &&
					<PromoDialog promo={ openPromo } onClose={ () => setOpenPromo(null) } />
			}
		</>
	);
};

export default PromoGrid;
